document.addEventListener('click', function (event) {
  const element = event.target.closest(
    '.copy-code, .announcement-bar__text strong'
  );

  if (!element) return;

  const couponCode = element.textContent.trim();

  if (!couponCode) return;

  navigator.clipboard.writeText(couponCode).then(function () {
    const originalText = element.textContent;

    element.textContent = 'COPIED!';

    setTimeout(function () {
      element.textContent = originalText;
    }, 2000);
  });
});